import * as React from 'react';
export var Cross = function Cross(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("polygon", {
    points: "48,41.1 30.9,24 48,6.9 41.1,0 24,17.1 6.9,0 0,6.9 17.1,24 0,41.1 6.9,48 24,30.9 41.1,48 "
  }));
};